import { Modal } from './lib/modal.ts';

const DOM = {};

const cacheDOM = () => {
    DOM.gmTriggers = document.querySelectorAll('[data-video-modal]');
    DOM.blogModal = document.querySelector('#blog-modal');
};

const init = () => {
    cacheDOM();

    // Blog video modals
    if (DOM.blogModal)
        Modal.init({
            modal: DOM.blogModal,
            openTriggers: '[data-micromodal-trigger]',
            closeTriggers: '[data-micromodal-close]',
            disableScroll: true,
            // Reload the video by touching the src
            onClose: (element) => {
                const iframe = element.querySelector('iframe');
                const src = iframe.getAttribute('src');
                iframe.setAttribute('src', src);
            },
        });

    // Testimonial video modals
    if (DOM.gmTriggers.length) {
        const distinct = (value, index, self) => self.indexOf(value) === index;

        const modalIds = [...DOM.gmTriggers]
            .map((x) => x.dataset.videoModal)
            .filter(distinct);

        modalIds.forEach((id) => {
            const modal = document.querySelector(id);
            const iframe = modal.querySelector('iframe');

            Modal.init({
                modal,
                openTriggers: document.querySelectorAll(
                    `[data-video-modal="${id}"]`
                ),
                closeTriggers: '[data-video-modal-close]',
                disableScroll: true,
                awaitOpenAnimation: true,
                onShow: (_, trigger) => {
                    const youtubeId = trigger.dataset.videoSrc;
                    iframe.setAttribute(
                        'src',
                        `https://www.youtube.com/embed/${youtubeId}?autoplay=1`
                    );
                },
                onClose: () => {
                    iframe.removeAttribute('src');
                },
            });
        });
    }
};

export default { init };
